import { WaybillIdView } from '../../../../models';
import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { ListRange, LoadAllFacade, SetInitialStateFacade } from '../../../../../common';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { ShipmentWaybillMaterialModel } from '../../models/shipment-waybill-materials.model';
import { ShipmentWaybillMaterialsState, ShipmentWaybillMaterialsStateModel } from './shipment-waybill-materials.state';
import { ShipmentWaybillItemFacade } from '../shipment-waybill-item.facade';
import {
  ShipmentWaybillMaterialsInitialState,
  ShipmentWaybillMaterialsLoad,
} from './shipment-waybill-materials.actions';

@Injectable({
  providedIn: 'root',
})
export class ShipmentWaybillMaterialsFacade implements LoadAllFacade, SetInitialStateFacade {
  listDto$: Observable<ShipmentWaybillMaterialsStateModel> = this.store.select(ShipmentWaybillMaterialsState.getState);
  items$: Observable<ShipmentWaybillMaterialModel[]> = this.store.select(ShipmentWaybillMaterialsState.getMaterials);
  loaded$: Observable<boolean> = this.store.select(ShipmentWaybillMaterialsState.getLoaded);

  constructor(private store: Store, private shipmentWaybillItemFacade: ShipmentWaybillItemFacade) {}

  loadAll(listRange?: ListRange): void {
    this.shipmentWaybillItemFacade.shipmentWaybillIdentifier$
      .pipe(take(1))
      .subscribe((waybillIdView: WaybillIdView) => {
        this.store.dispatch(new ShipmentWaybillMaterialsLoad({ ...listRange, waybillIdView }));
      });
  }

  setInitialState(): void {
    this.store.dispatch(new ShipmentWaybillMaterialsInitialState());
  }
}
